const Preconditions = require('./Preconditions.js'); 
const Labels = require('./Labels.js'); 

function Avatar(label, color_hash)
{
    this.label = label;
    this.color_hash = color_hash;
    this.force_letter = null;
    this.force_color = null;
}

Avatar.prototype.forceLetter = function(value)
{
    this.force_letter = value;
}

Avatar.prototype.forceColor = function(value)
{
    this.force_color = value;
}

Avatar.prototype.hasImage = function()
{
    return false;
}

Avatar.prototype.getImage = function()
{
    return null;
}

Avatar.prototype.getLetter = function()
{
    if ( this.force_letter != null ) 
        return this.force_letter;

    let label = this.label;

    if ( label.startsWith("E164:") || label.startsWith('(') || label.length == 0 )
        return '#';
    
    return label.toUpperCase().substring(0,1);
}

Avatar.prototype.getColor = function()
{
    if ( this.force_color != null ) 
        return this.force_color;

    let hash = Math.abs(hashString(this.color_hash));

    if ( hash % 5 === 0 ) return '#5D647C';
    if ( hash % 5 === 1 ) return '#77B2E8';
    if ( hash % 5 === 2 ) return '#75EABD';
    if ( hash % 5 === 3 ) return '#F7CD66';
    if ( hash % 5 === 4 ) return '#CAD0E0';

    return '#75EABD'
}

function hashString(str)
{
    Preconditions.checkString(str);

    let hash = 0;

    for ( let i = 0; i < str.length; i++ )
    {
        let chr = str.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }

    return hash;
}

module.exports = Avatar;





